import { createRef, RefObject, useEffect, useRef, useState } from "react";

import { Icon } from "@newsela/angelou";

import { FilterSection } from "@/search/Langston/FilterPanel/FilterSection";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import { LangstonParameterSchema } from "@/search/Langston/LangstonParameterSchema";
import { InstructionalFeatureCheckbox } from "./InstructionalFeatureCheckbox";
import { fieldsetCss, legendCss } from "./InstructionalFeature.styles";
import { InstructionSupportFiltersValuesEnum } from "./InstructionalFeature.constants";

const instructionalFeatureOptions =
  LangstonParameterSchema.instructional_features.values;

export const InstructionalFeature = () => {
  const { isTeacher, activeELALicense, canSeeFormative, activeStemLicense } =
    useGetUserProperties();

  const checkboxRefs = useRef(
    instructionalFeatureOptions.map(() => createRef<HTMLInputElement>()),
  );

  const [isDomReady, setIsDomReady] = useState(false);

  useEffect(() => {
    setIsDomReady(true);
  }, []);

  const canSeePowerWords = activeELALicense;
  const canSeeDecodables = isTeacher && activeELALicense;
  const canSeeGenius = activeStemLicense || activeELALicense;

  return (
    <FilterSection defaultCollapsed={false} title="Instructional support">
      <fieldset css={fieldsetCss}>
        <legend css={legendCss}>Filter content by instructional support</legend>
        {instructionalFeatureOptions.map((option, index) => {
          const currentRef = checkboxRefs?.current?.[
            index
          ] as RefObject<HTMLInputElement>;
          const targetElement = currentRef?.current?.nextSibling
            ?.nextSibling as Element;

          const paramName =
            option?.paramName ||
            LangstonParameterSchema.instructional_features.key;

          if (
            option.value === InstructionSupportFiltersValuesEnum.decodable &&
            !canSeeDecodables
          )
            return null;

          if (
            option.value === InstructionSupportFiltersValuesEnum.power_words &&
            !canSeePowerWords
          )
            return null;

          if (
            option.value ===
              InstructionSupportFiltersValuesEnum.generation_genius_video &&
            !canSeeGenius
          )
            return null;

          if (
            option.value === InstructionSupportFiltersValuesEnum.formative &&
            !canSeeFormative
          )
            return null;

          return (
            <InstructionalFeatureCheckbox
              key={index}
              paramName={paramName}
              option={option}
              currentRef={currentRef}
              isDomReady={isDomReady}
              targetElement={targetElement}
              IconComponent={<Icon SvgComponent={option.SvgComponent} />}
            />
          );
        })}
      </fieldset>
    </FilterSection>
  );
};
